import styled from "styled-components";

export const getStyledHeader = () => styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    span{
        font-size: 4em;
        font-family: 'Playfair Display', serif;
    }

    aside{
        display: flex;
        align-items: center;
        column-gap: 3vw;
        font-size: 1.5em;
        color: #5F5F64;
        margin-top: 3vh;
        cursor: pointer;
    }
`